/**
 * The `hogc_one_id` a CMS form is opened with when the app builds the URL itself
 * (the `form-server-prefills` flag off, or the prefills call failed). A member is
 * its member id, as before. A login still waiting for its leader's link has no
 * member id and is `au-{appUserId}`, so the submission can be tied to the person
 * once the link lands; the API's server-built prefills send the same value. The
 * prefix is the one OneSignal external ids use (onesignal-external-id.js): a bare
 * login id could equal an unrelated member's id.
 */
export function formHogcOneId(profile) {
  if (profile?.id) return profile.id;
  if (profile?.hasNoMember && profile.appUserId) return `au-${profile.appUserId}`;
  return profile?.id;
}
